import { apiClient } from './client'
import type {
  QuizScript,
  QuizSolveRequest,
  SolveResult,
} from '@quebon/shared-learning'

function encodeVarsToBase64(vars: Record<string, unknown>): string {
  return btoa(JSON.stringify(vars))
}

export const quizScriptApi = {
  getContentQuizzes: async (
    contentId: number,
    location?: 'pre' | 'post' | 'selected' | 'review' | 'block' | 'applied' | 'explanation' | 'checkup' | 'wrapup' | 'aiq',
    showAnswer = false,
    useFixedVars = true,
    includeSolveResult = false
  ): Promise<QuizScript[]> => {
    const response = await apiClient.get(
      `/quiz/contents/${contentId}/quizzes`,
      { params: { location, showAnswer, useFixedVars, includeSolveResult } }
    )
    return response.data.data
  },

  getQuizzes: async (
    ids: string[],
    showAnswer = false,
    useFixedVars = true
  ): Promise<QuizScript[]> => {
    const response = await apiClient.get('/quiz/quizzes', {
      params: { ids: ids.join(','), showAnswer, useFixedVars },
    })
    return response.data.data
  },

  getQuiz: async (
    quizId: string,
    showAnswer = false,
    vars?: Record<string, unknown>,
    useFixedVars?: boolean,
    includeSolveResult = false
  ): Promise<QuizScript> => {
    const headers: Record<string, string> = {}
    if (vars) {
      headers['x-qb-quiz-vars-base64'] = encodeVarsToBase64(vars)
    }
    const response = await apiClient.get(`/quiz/quizzes/${quizId}`, {
      params: { showAnswer, useFixedVars, includeSolveResult },
      headers,
    })
    return response.data.data
  },

  solve: async (
    quizId: string,
    request: QuizSolveRequest
  ): Promise<SolveResult> => {
    const response = await apiClient.post(
      `/quiz/quizzes/${quizId}/solve`,
      request
    )
    return response.data.data
  },
}
